<template>
  <div>
    <hero-card />
    <airport-transfer-widget class="mt-4" />
    <how-it-works />
    <highlights-card />
    <foravila-guarantee />
  </div>
</template>

<script>
import HeroCard from "@/views/foravila/services/airport-transfer/components/HeroCard.vue";
import AirportTransferWidget from "@/views/foravila/services/airport-transfer/components/AirportTransferWidget.vue";
import HowItWorks from "@/views/foravila/services/airport-transfer/components/HowItWorks.vue";
import HighlightsCard from "@/views/foravila/services/airport-transfer/components/HighlightsCard.vue";
import ForavilaGuarantee from "@/views/foravila/services/components/ForavilaGuarantee.vue";

export default {
  components: {
    HeroCard,
    AirportTransferWidget,
    HowItWorks,
    HighlightsCard,
    ForavilaGuarantee
  }
};
</script>
